<!--

  Author: dhersey
  Date: 02/24/2025
  Desc: New inquiry form component, initially created for WealthEngine
    Campaign test.

-->
<template>
  <form class="we-contact-form" v-if="!isSubmitted" name="inquiryForm" @submit.prevent>
    <div class="v4-section-header-heavy color-gradient-shark">
      Get to know us.
    </div>
    <div class="v4-base-header-nova color-navy">
      Schedule a Call or a Demo
    </div>

    <div class="v4-section-paragraph enforce-p-normal color-reserved" style="padding-top: 1em">
      * Required
    </div>

    <!-- Fname -->
    <div class="input-type" style="margin-top: 1em;">
      <div class="v4-base-header-nova ">
        <span class="color-gradient-shark">First Name</span> <span class="color-reserved">*</span>
      </div>
      <input type="text" name="first_name" v-model="first_name" required class="input-box-dashed">
    </div>

    <!-- Lname -->
    <div class="input-type">
      <div class="v4-base-header-nova">
        <span class="color-gradient-shark">Last Name</span> <span class="color-reserved">*</span>
      </div>
      <input type="text" name="last_name" v-model="last_name" required class="input-box-dashed">
    </div>

    <!-- Email -->
    <div class="input-type">
      <div class="v4-base-header-nova">
        <span class="color-gradient-shark">Email</span> <span class="color-reserved">*</span>
      </div>
      <input type="email" name="email" v-model="email" required class="input-box-dashed">
    </div>

    <!-- Phone -->
    <div class="input-type">
      <div class="v4-base-header-nova">
        <span class="color-gradient-shark">Phone</span> <span class="color-reserved">*</span>
      </div>
      <input type="tel" name="phone" v-model="phone" required class="input-box-dashed">
    </div>

    <div class="v4-base-header-nova color-gradient-shark">Attend a Club Event</div>
    <p class="v4-body-paragraph color-storm">Barton & Gray hosts many events throughout all of our harbors and islands, providing a fun way to learn more about the Club. </p>
    <div class="v4-base-header-nova color-gradient-shark">Upcoming Events</div>
    <p class="v4-base-header-nova color-storm">Florida Discovery Days<br>Charleston Discovery Days<br>Sail GP New York</p>

    <div class="row-option" style="margin-bottom: 2em;">
      <input type="checkbox" v-model="see_schedule" class="input-box-dashed checkbox-option">
      <div class="v4-base-header-nova color-gradient-shark">See our Schedule of Events</div>
    </div>

    <div class="v4-base-header-nova color-gradient-shark">Request a Club Folio</div>
    <p class="v4-base-header-nova color-storm">If you would like us to send our Club Folio in the mail please select the checkbox below and then provide a mailing address.</p>

    <div class="row-option">
      <input type="checkbox" v-model="provide_mailing_address" class="input-box-dashed checkbox-option">
      <div class="v4-base-header-nova color-gradient-shark">Provide Mailing Address</div>
    </div>

    <!-- Mailing Address -->
    <div class="input-type" style="margin-top: 0.5em;" :class="isHidden(provide_mailing_address)">
      <input type="text" name="mailing_address" v-model="mailing_address" class="input-box-dashed">
    </div>

    <button style="width: 100%; margin-top: 1em;" class="v4-download-button bg-color-gradient-cloud" type="submit" @click="submitClicked()">
      <div class="soft-square bg-color-gradient-sky">
        <img style="width: 30px;" class="filter-gold" src="https://cloud.bartonandgray.com/library/ux/icons/chevrons/arrow-next.svg">
      </div>
      <div class="button-label color-gradient-shark">SUBMIT INFORMATION</div>
    </button>
  </form>
  <div class="we-contact-form" v-if="isSubmitted">
    <div class="v4-section-header-heavy color-gradient-shark">Thank you for reaching out!</div>
    <div class="v4-base-header-nova color-navy italic" style="padding-top: 1em;">Your request has been received, and our team will be in touch soon to schedule your call or demo.</div>
    <div class="v4-base-header-nova color-gradient-shark" style="padding-top: 1em;">Next Steps:</div>
    <ul class="v3-standard-list small-bullets color-storm">
      <li style="display: none;"><b>Check your inbox</b> for a confirmation email from <i>Barton &amp; Gray</i>.</li>
      <li><a href="/membership-home"><b>Explore our Experiences</b> -- View Our Club Offerings.</a></li>
      <li><b>Follow us on Instagram</b> for the latest adventures -- <a href="https://www.instagram.com/marinersclub/" style="color: #4a8ac9">@marinersclub</a></li>
    </ul>
    <div class="v4-base-header-nova color-navy italic">We look forward to welcoming you aboard!</div>
  </div>
  <div v-if="isDebug">
    first_name: {{ first_name }}<br>
    last_name: {{ last_name }}<br>
    email: {{ email }}<br>
    phone: {{ phone }}<br>
    see_schedule: {{ see_schedule }}<br>
    provide_mailing_address: {{ provide_mailing_address }}<br>
    mailing_address: {{ mailing_address }}<br>
    userData: {{ userData }}
  </div>
</template>

<script setup>
import { ref } from 'vue';
import { inquireService }  from 'src/Inquiries/InquireService'
import { doOnceService } from 'src/Mwk/DoOnceService'

const isDebug = false;

let first_name = ref("");
let last_name = ref("");
let email = ref("");
let phone = ref("");
let see_schedule = ref(false);
let provide_mailing_address = ref(false);
let mailing_address = ref("");

let isSubmitted = ref(false);

function isHidden(x){
  return x ? 'active' : 'inactive';
}

function submitClicked(){

  let userData = {
    'first_name': first_name.value,
    'last_name': last_name.value,
    'email': email.value,
    'phone': phone.value,
    'products_map':{
      'events': false,
    },
    'mailing_address': false,
    'property': 'we',
    'notAskingHarbors': true,
    'source_code': ''
  }

  if(provide_mailing_address.value){
    userData.mailing_address = mailing_address.value;
  }

  if(see_schedule.value){
    userData.products_map.events = true;
  }
  
  if (isReady()) {
    if (! inquireService.valid(userData)) {
      alert("Please enter your name, email, and harbors of interest")
    } else {
      submitForm(userData)
    }

  } else {
    return
  }
}

function submitForm(userdata){
  doOnceService.doOnce('inquirySubmit', submitImpl(userdata))
}

function submitImpl(userdata){
  var promise = new Promise((resolve, reject) => {
    inquireService.submit(userdata).then(() => {
      resolve();
    }).catch((err) => {
      console.log("SubmitImpl BGInquiry Got err in caller", err)
      reject();
    })
    
  })
  
  isSubmitted.value = true;
  return promise;
}

function isReady(){
  let flag = 0;

  if (!validateEmail(email.value)) {
    flag = 1;
  }

  // first_name, last_name, email, phone required
  if((first_name.value == '') || (last_name.value == '') || (email.value == '') || (phone.value == null)){
    flag = 1;
  }

  if (flag == 0) {
    return true;
  } else {
    return false;
  }
}

function validateEmail(email_text){
  var mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
  if (email_text.match(mailformat) || email_text == '') {
    return true;
  } else {
    return false;
  } 
};

</script>

<style scoped lang="scss">

input{
  &:invalid{
    &:focus{
      outline: none;
      border: 1px dashed red;
    }
  }
}

.input-type{
  transition: 0.15s ease-in-out;
  &.inactive{
    opacity: 0;
    input{
      line-height: 0;
      padding: 0;
      border: none;
      user-select: none;
    }
  }
  &.active{
    opacity: 1;
  }
}

</style>